<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="studentTracking"
  >

    <div class="align-items-baseline display-flex-row">
      <form
        autocomplete="off"
        class="m-form-row m-form-search"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomInputPrimary
          v-model="simpleFilter.academia_url"
          :disabled="pagination.showLoadingState"
          v-on:keyup.enter="searchSimpleFilter"
          name="academia_url"
          placeholder="url de la academia"
          type="text"
          wrapperClass="a-input-wrapper-row"
        />

        <AtomInputPrimary
          v-model="simpleFilter.email"
          :disabled="pagination.showLoadingState"
          name="email"
          placeholder="usuario@email.com"
          type="email"
          wrapperClass="a-input-wrapper-row"
          @input="searchSimpleFilter"
        />

        <AtomSelectPrimary
          v-model="simpleFilter.proyecto"
          :disabled="pagination.showLoadingState"
          :elements="proyectoElements"
          keyField="id"
          name="proyecto"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomSelectPrimary
          v-model="simpleFilter.completado"
          :disabled="pagination.showLoadingState"
          :elements="completadoElements"
          keyField="id"
          name="completado"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomInputPrimary
          v-model.number="simpleFilter.sin_actividad_dias"
          :disabled="pagination.showLoadingState"
          name="sin_actividad_dias"
          :placeholder="$t('mEditionBillingStudentTracking.filters.inactivityPlaceholder')"
          type="number"
          wrapperClass="a-input-wrapper-row"
          v-on:keyup.enter="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reload"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <form
        autocomplete="off"
        class="m-form-row margin-left-auto"
        name="download-csv-form"
        @submit.prevent="readTrackingAlumnosExportar"
      >
        <AtomButtonPrimary
          :button-primary="buttonPrimary"
          :disabled="pagination.showLoadingState || !alumnos.length"
        />
      </form>
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="alumnos.length">
          <th
            class="text-align-left"
            width="22%"
          >
            {{ $t('mEditionBillingStudentTracking.table.thStudent') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
            {{ $t('mEditionBillingStudentTracking.table.thLastLogin') }}
          </th>
          <th
            class="text-align-left"
            width="17%"
          >
            {{ $t('mEditionBillingStudentTracking.table.thProject') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingStudentTracking.table.thLastAccess') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingStudentTracking.table.thLastSeen') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionBillingStudentTracking.table.thProgress') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
            {{ $t('mEditionBillingStudentTracking.table.thState') }}
          </th>
          <th
            class="text-align-center"
            width="6%"
          >
            {{ $t('mEditionBillingStudentTracking.table.thDetail') }}
          </th>
        </tr>
        <tr
          v-for="(alumno, index) in alumnos"
          :key="index"
          class="row-data"
        >
          <td class="text-align-left">
            <span class="display-flex-column user-info">
              <span class="ellipsis">
                {{ alumno.razon_social ? alumno.razon_social : alumno.email }}
              </span>
              <small class="ellipsis font-weight-regular">
                {{ alumno.email }}
              </small>
            </span>
          </td>
          <td class="text-align-center text-white-space-nowrap">
            <span
              v-if="alumno.ultimo_login"
              class="display-flex-column"
            >
              <span>{{ $moment.parseZone(alumno.ultimo_login).format('D MMM YYYY HH:mm') }}</span>
              <small class="font-weight-regular">{{ alumno.ultimo_login_ip ? alumno.ultimo_login_ip : '' }}</small>
            </span>
            <span v-else>
              {{ $t('mEditionBillingStudentTracking.labels.never') }}
            </span>
          </td>
          <td class="text-align-left">
            <span class="display-flex-column">
              <span class="ellipsis">{{ alumno.proyecto_titulo }}</span>
              <small
                :class="alumno.acceso_activo
                  ? 'font-weight-regular text-color-success'
                  : 'font-weight-regular text-color-danger'"
              >
                {{ alumno.acceso_activo
                  ? $t('mEditionBillingStudentTracking.labels.accessActive')
                  : $t('mEditionBillingStudentTracking.labels.accessInactive') }}
              </small>
            </span>
          </td>
          <td class="text-align-center text-white-space-nowrap">
            <span v-if="alumno.ultimo_acceso">
              {{ $moment.parseZone(alumno.ultimo_acceso).format('D MMM YYYY HH:mm') }}
            </span>
            <span v-else>
              {{ $t('mEditionBillingStudentTracking.labels.never') }}
            </span>
          </td>
          <td class="text-align-center text-white-space-nowrap">
            <span v-if="alumno.ultimo_visto">
              {{ $moment.parseZone(alumno.ultimo_visto).format('D MMM YYYY HH:mm') }}
            </span>
            <span v-else>
              {{ $t('mEditionBillingStudentTracking.labels.never') }}
            </span>
          </td>
          <td class="text-align-center text-white-space-nowrap">
            <span class="display-flex-column">
              <span>{{ alumno.nodos_vistos }}/{{ alumno.nodos_totales }} · {{ alumno.porcentaje }}%</span>
              <small
                v-if="alumno.nodos_activos"
                class="font-weight-regular"
              >
                {{ $t('mEditionBillingStudentTracking.labels.progressActive') }}
                {{ alumno.nodos_vistos }}/{{ alumno.nodos_activos }} · {{ alumno.porcentaje_activos }}%
              </small>
            </span>
          </td>
          <td class="text-align-center">
            <span
              :class="alumno.completado
                ? 'font-weight-bold text-color-success'
                : 'font-weight-regular'"
            >
              {{ alumno.completado
                ? $t('mEditionBillingStudentTracking.labels.completed')
                : $t('mEditionBillingStudentTracking.labels.inProgress') }}
            </span>
          </td>
          <td class="text-align-center">
            <a
              :data-tooltip-text="$t('mEditionBillingStudentTracking.tooltip.detail')"
              :href="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.studentTracking.subject')}/${academiaId}/${$t('mEditionMenu.billing.studentTracking.children.detail.subedition')}/${alumno.usuario}`"
              class="a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom margin-left-xsmall margin-right-xsmall"
              target="_blank"
            >
              <i class="fas fa-chart-line"></i>
            </a>
          </td>
        </tr>
      </table>
      <p
        v-show="!alumnos.length"
        class="text-align-center"
      >
        {{ $t('mEditionBillingStudentTracking.messages.noData') }}
      </p>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import configApp from '@/config'
import { validateEmail } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionBillingStudentTracking',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academiaId: '',

      alumnos: [],

      buttonPrimary: {
        action: this.$t('mEditionBillingStudentTracking.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reload: {
          class: 'a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionBillingStudentTracking.tooltip.reload'),
          type: 'button'
        }
      },

      completadoElements: [
        { id: '', name: this.$t('mEditionBillingStudentTracking.filters.completedAll') },
        { id: 1, name: this.$t('mEditionBillingStudentTracking.filters.completedYes') },
        { id: 0, name: this.$t('mEditionBillingStudentTracking.filters.completedNo') }
      ],

      filter: {
        completado: '',
        email: '',
        limite: 10,
        pagina: 1,
        proyecto: '',
        sin_actividad_dias: ''
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      proyectoElements: [
        { id: '', name: this.$t('mEditionBillingStudentTracking.filters.projectAll') }
      ],

      proyectosAcademiaId: '',

      showLoadingState: true,

      simpleFilter: {
        academia_url: '',
        completado: '',
        email: '',
        proyecto: '',
        sin_actividad_dias: ''
      }
    }
  },

  created () {
    this.simpleFilter.academia_url = configApp.academyUrl
    this.readAcademiaId()
  },

  methods: {
    readAcademiaId () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('academia', 'readAcademiaUrl', {}, [this.simpleFilter.academia_url])
          .then(response => {
            this.academiaId = response.data.id
            this.readProyectosAcademia()
            this.readTrackingAlumnos()
          })
          .catch(error => {
            console.log(error)
            this.showLoadingState = false
            this.pagination.showLoadingState = false
            this.$alerts.pushAlert('mEditionBillingStudentTracking', 'readAcademiaId', 'error', 'a-alert-danger')
          })
      }
    },

    readProyectosAcademia () {
      if (this.proyectosAcademiaId === this.academiaId) {
        return
      }
      this.proyectosAcademiaId = this.academiaId
      this.$services.read('proyecto', 'readProyectos', {}, [], { academia: this.academiaId, pagina: 1, limite: 100 })
        .then(response => {
          this.proyectoElements = [
            { id: '', name: this.$t('mEditionBillingStudentTracking.filters.projectAll') },
            ...response.data.proyectos.map(p => ({ id: p.id, name: p.titulo }))
          ]
        })
        .catch(error => {
          console.log(error)
        })
    },

    readTrackingAlumnos () {
      this.$services.read('tracking', 'readTrackingAcademiaAlumnos', {}, [this.academiaId], this.filter)
        .then(response => {
          this.alumnos = response.data.data
          this.pagination.currentQuantity = this.alumnos.length
          this.pagination.totalPages = response.data.pages
          this.pagination.totalQuantity = response.data.total
          this.pagination.showLoadingState = false
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.alumnos = []
          this.pagination.currentQuantity = 0
          this.pagination.totalPages = 0
          this.pagination.totalQuantity = 0
          this.pagination.showLoadingState = false
          this.showLoadingState = false
          this.$alerts.pushAlert('mEditionBillingStudentTracking', 'readTrackingAlumnos', 'error', 'a-alert-danger')
        })
    },

    readTrackingAlumnosExportar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('tracking', 'readTrackingAcademiaAlumnosExportar', {}, [this.academiaId], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionBillingStudentTracking.files.tracking')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingStudentTracking', 'readTrackingAlumnosExportar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingStudentTracking', 'readTrackingAlumnosExportar', 'error', 'a-alert-danger')
          })
      }
    },

    reloadListing () {
      this.resetFilters()
      this.setPaginationCurrentPage(1)
    },

    resetFilters () {
      // Se mantiene la academia ya buscada; solo se limpian los demas filtros
      this.simpleFilter = {
        academia_url: this.simpleFilter.academia_url || configApp.academyUrl,
        completado: '',
        email: '',
        proyecto: '',
        sin_actividad_dias: ''
      }

      this.filter = {
        completado: '',
        email: '',
        limite: 10,
        pagina: 1,
        proyecto: '',
        sin_actividad_dias: ''
      }
    },

    searchSimpleFilter () {
      if (validateEmail(this.simpleFilter.email) ||
        this.simpleFilter.email === '') {
        this.filter.completado = this.simpleFilter.completado
        this.filter.email = this.simpleFilter.email
        this.filter.proyecto = this.simpleFilter.proyecto
        this.filter.sin_actividad_dias = this.simpleFilter.sin_actividad_dias
        this.setPaginationCurrentPage(1)
      }
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readAcademiaId()
    }
  }
}
</script>
